export const FH_COLORS = {
  green: "#5cb85c",
  greenDark: "#3f9c40",
  lightGreen: "#8fd18f",
  blue: "#2f8fd8",
  amber: "#f0ad2e",
  orange: "#ef8b3c",
  red: "#e0484c",
  slate: "#2b3945",
  muted: "#8a97a3",
  ink: "#22303c",
  track: "#eef1f4",
};

export const BAR_COLORS = [
  FH_COLORS.blue,
  FH_COLORS.green,
  FH_COLORS.amber,
  FH_COLORS.red,
  "#7e57c2",
];

/** Convert decimal hours from API into a readable duration string. */
export const formatHoursToDuration = (hours) => {
  const totalSeconds = Math.max(0, Math.round(Number(hours || 0) * 3600));
  const days = Math.floor(totalSeconds / 86400);
  const hoursPart = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) {
    return {
      main: `${days} d ${hoursPart} h`,
      sub: `${minutes} m ${seconds} s`,
    };
  }
  if (hoursPart > 0) {
    return {
      main: `${hoursPart} h ${minutes} m`,
      sub: `${seconds} s`,
    };
  }
  return {
    main: `${minutes} m`,
    sub: `${seconds} s`,
  };
};

export const formatNumber = (value, decimals = 0) => {
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  return num.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const clampPercent = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;
  return Math.max(0, Math.min(100, num));
};

export const donutDash = (percent, radius = 52) => {
  const circumference = 2 * Math.PI * radius;
  const filled = (clampPercent(percent) / 100) * circumference;
  return {
    circumference,
    filled,
    dashArray: `${filled} ${circumference}`,
  };
};

export const semicircleDash = (percent, radius = 62) => {
  const length = Math.PI * radius;
  const filled = (clampPercent(percent) / 100) * length;
  return {
    length,
    filled,
    dashArray: `${filled} ${length}`,
  };
};

export const scoreBarColor = (score) => {
  if (score >= 90) return FH_COLORS.green;
  if (score >= 80) return FH_COLORS.lightGreen;
  if (score >= 70) return FH_COLORS.orange;
  if (score >= 60) return FH_COLORS.amber;
  return FH_COLORS.red;
};

/** Average numeric values from a plate → cost map (e.g. costPerKm). */
export const averageMapValues = (map) => {
  const values = Object.values(map || {})
    .map((v) => Number(v))
    .filter((n) => !Number.isNaN(n) && Number.isFinite(n));
  if (!values.length) return 0;
  return values.reduce((sum, n) => sum + n, 0) / values.length;
};

/**
 * Maintenance cost efficiency score from fmd/14 (current) vs fmd/26 (historical).
 * deltaPct = (currentAvg - historicalAvg) / historicalAvg * 100
 * ≥15% lower → 100 | 5–15% lower → 95 | ±±5% → 90 | 5–15% higher → 80 | >15% higher → 70
 */
export const maintenanceCostEfficiencyScore = (currentAvg, historicalAvg) => {
  const current = Number(currentAvg) || 0;
  const historical = Number(historicalAvg) || 0;
  if (historical <= 0) {
    return current <= 0 ? 0 : 90;
  }
  const deltaPct = ((current - historical) / historical) * 100;
  console.log("deltaPct====>", deltaPct);
  if (deltaPct <= -15) return 100;
  if (deltaPct < -5) return 95;
  if (deltaPct <= 5) return 90;
  if (deltaPct <= 15) return 80;
  return 70;
};
